import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { getOfferProducts } from '../../services/api';

const OfferBanner = () => {
  const navigate = useNavigate();
  const [hasOffers, setHasOffers] = useState(false);

  useEffect(() => {
    const checkOffers = async () => {
      try {
        const response = await getOfferProducts();
        if (response.data.data && response.data.data.length > 0) {
          setHasOffers(true);
        }
      } catch (error) {
        console.error('Error checking offers:', error);
      }
    };
    checkOffers();
  }, []);

  if (!hasOffers) return null;

  return (
    <Box
      sx={{
        py: 6,
        background: 'linear-gradient(135deg, #ff6b35 0%, #f7c948 50%, #ff6b35 100%)',
        textAlign: 'center',
        color: '#fff',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: -50,
          right: -50,
          width: 200,
          height: 200,
          borderRadius: '50%',
          bgcolor: 'rgba(255,255,255,0.1)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: -30,
          left: -30,
          width: 150,
          height: 150,
          borderRadius: '50%',
          bgcolor: 'rgba(255,255,255,0.1)',
        }}
      />
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
        <LocalOfferIcon sx={{ fontSize: 48, mb: 1 }} />
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            mb: 1,
            fontSize: { xs: '1.8rem', md: '2.5rem' },
            textShadow: '2px 2px 4px rgba(0,0,0,0.2)',
          }}
        >
          Festival Special Offers!
        </Typography>
        <Typography
          sx={{
            fontSize: '1.1rem',
            opacity: 0.95,
            mb: 3,
          }}
        >
          Grab amazing deals on premium dry fruits and more
        </Typography>
        <Button
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          onClick={() => navigate('/offers')}
          sx={{
            bgcolor: '#fff',
            color: '#ff6b35',
            fontWeight: 700,
            px: 4,
            py: 1.5,
            fontSize: '1rem',
            borderRadius: 3,
            '&:hover': { bgcolor: '#f5f5f5' },
          }}
        >
          View All Offers
        </Button>
      </Container>
    </Box>
  );
};

export default OfferBanner;
